import {
    isValidElement,
    type ReactNode,
    Children,
    useMemo,
    type FC
} from "react";
import {
    View
} from "react-native";
import type IBubbleGroupProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    BubbleGroupPosition,
    BubbleAlign
} from "../../type";
import {
    BubbleGroupContext
} from "../../context";

const BubbleGroupItem: FC<{
    position: BubbleGroupPosition;
    children: ReactNode;
    align: BubbleAlign;
}> = ({
    children,
    position,
    align
}) => {
    const context = useMemo(() => ({
        position,
        align
    }), [
        position,
        align
    ]);

    return <BubbleGroupContext.Provider
        value={context}
    >
        {children}
    </BubbleGroupContext.Provider>;
};

const BubbleGroup: FC<IBubbleGroupProps> = ({
    align = "start",
    customTheme,
    children,
    style,
    ...props
}) => {
    const {
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        container: containerDynamicStyle
    } = useStyles({
        spaces
    });

    const items = Children.toArray(children).filter(isValidElement);

    const getPosition = (index: number): BubbleGroupPosition => {
        if(items.length === 1) {
            return "single";
        }

        if(index === 0) {
            return "first";
        }

        return index === items.length - 1 ? "last" : "middle";
    };

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        role="group"
    >
        {
            items.map((item, index) => <BubbleGroupItem
                position={getPosition(index)}
                key={item.key ?? index}
                align={align}
            >
                {item}
            </BubbleGroupItem>)
        }
    </View>;
};
export default BubbleGroup;
